/* 
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
*/

import React, { Component } from "react";
import Label from "../../components/label";
import Anchor from "../../components/anchor";
import otherLinks from "../../routes/otherLinks";
import MakeAPICall from "../../apiCalls/common";
import {  appConstants } from "../../apiRoutes";

class LegalPage extends Component {
  constructor(props){
    super(props);
    this.constants = props.constants;
  }
  
  componentDidMount() {
    window.scrollTo(0, 0);
    // get constant
  }
  
  render() {
    return (
      <div className="row rounded p-3 legal-page">
        <div className="col-sm-3 p-3">
          <Label title="Legal" className="big" />
        </div>
        <div className="col-sm-12 border-bottom"></div>

        <div className="col-sm-12 mt-4">
          <Anchor
            title="Good Practice & Safe Prescribing Policy Book"
            target="_blank"
            className="primary-color w-100 thin-font"
            href={this.constants.goodPracticePolicy}
          />
        </div>
        <div className="col-sm-12 mt-2">
          <Anchor
            title="My Health Record Security & Access Policy"
            target="_blank"
            className="primary-color w-100 thin-font"
            href={this.constants.myHealthRecordSecurityAndAccessPolicy}
          />
        </div>
        <div className="col-sm-12 mt-2">
          <Anchor
            title="My Health Record Training Policy"
            target="_blank"
            className="primary-color w-100 thin-font"
            href={this.constants.myHealthRecordTrainingPolicy}
          />
        </div>
        <div className="col-sm-12 mt-2">
          <Anchor
            title="Service Agreement"
            target="_blank"
            className="primary-color w-100 thin-font"
            href={this.constants.serviceAgreement}
          />
        </div>
        <div className="col-sm-12 mt-2">
          <Anchor
            title="Verification Process"
            target="_blank"
            className="primary-color w-100 thin-font"
            // href={otherLinks.verificationProcess}
            href={this.constants.validationProcess}
          />
        </div>
        <div className="col-sm-12 mt-2">
          <Anchor
            title="Privacy Policy"
            target="_blank"
            className="primary-color thin-font"
            // href={otherLinks.privacyPolocy}
            href={this.constants.privacyPolicy }
          />
        </div>
        
        {/* API Call */}
      </div>
    );
  }
}

export default LegalPage;
